import { render, staticRenderFns } from "./SMPTE.vue?vue&type=template&id=736bfe2e&scoped=true&"
import script from "./SMPTE.vue?vue&type=script&lang=js&"
export * from "./SMPTE.vue?vue&type=script&lang=js&"
import style0 from "./SMPTE.vue?vue&type=style&index=0&id=736bfe2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736bfe2e",
  null
  
)

export default component.exports